import { motion } from "framer-motion";

const FooterComponent = ({
    darkMode,
    stats,
    footerBorder,
    secondaryTextColor
}) => {
  return (
    <>
      {/* Footer */}
      <motion.footer
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.5 }}
        className={`mt-12 pt-6 border-t ${footerBorder} text-center ${secondaryTextColor} text-sm`}
      >
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <div>
            <p>NexusFlow Rule Engine • Real-time Analytics Dashboard • {new Date().getFullYear()}</p>
            <div className="flex flex-wrap items-center justify-center gap-2 mt-1">
              <span className="flex items-center gap-1">
                <div className={`w-2 h-2 ${darkMode ? "bg-green-500" : "bg-green-600"} rounded-full animate-pulse`} />
                Rules Engine Active
              </span>
              <span>•</span>
              <span>Products Analyzed: {stats?.total}</span>
              <span>•</span>
              <span>Avg Confidence: {stats?.averageConfidence}%</span>
            </div>
          </div>
          <div className={`flex items-center gap-2 ${darkMode ? "bg-gray-800" : "bg-gray-100"} px-4 py-2 rounded-lg`}>
            <div className="flex items-center gap-1">
              <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse" />
              <span className="text-xs">Sales: {stats?.totalSales}</span>
            </div>
            <div className="flex items-center gap-1">
              <div className="w-2 h-2 bg-blue-500 rounded-full" />
              <span className="text-xs">Stock: {stats?.totalStock}</span>
            </div>
          </div>
        </div>
      </motion.footer>
    </>
  )
}

export default FooterComponent